var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"256","height":"256","fill":"inherit","key":0}),React.createElement("path",{"d":"M60 92V28H84V92H60Z","fill":"#FEB914","key":1}),React.createElement("path",{"d":"M92 228V164H116V228H92Z","fill":"#F03812","key":2}),React.createElement("path",{"d":"M60 156V132H138L193.5 228H165.569L124 156H60Z","fill":"#2C9FA2","key":3}),React.createElement("path",{"d":"M60 100V124H138L193.5 28H165.569L124 100H60Z","fill":"#FE8826","key":4}),React.createElement("path",{"d":"M92 92V28H116V92H92Z","fill":"#F03812","key":5}),React.createElement("path",{"d":"M60 228V164H84V228H60Z","fill":"#FEB914","key":6})]);
}

Logo.defaultProps = {"width":"256","height":"256","viewBox":"0 0 256 256"};

module.exports = Logo;

Logo.default = Logo;
